module.exports = __webpack_public_path__ + "img/open.ef6cbf75.jpg";